import decode from './decode'
import handleLogin from './handleLogin'
import setUser from './setUser'
import handleLogout from './handleLogout'

export { decode }
export { handleLogin }
export { setUser }
export { handleLogout }

const tokenServiceClient = {
  decode,
  handleLogin,
  setUser,
  handleLogout
}

export default tokenServiceClient
